/* Mega menu behavior per handoff INTERACTIONS.md:
   - opens on hover with 150ms intent delay (pointer-fine devices only)
   - page behind dims 45% (body class -> CSS overlay)
   - closes on scroll, ESC (Dawn), blur (Dawn), or pointer leave (~240ms)
   - arrow keys traverse columns

   BUG-1 fix: the panel is absolutely positioned flush under the header, so the
   pointer must cross a gap between the summary and the panel. Previously only
   the summary got pointerenter and the close timer was short, so the gap fired
   details' pointerleave and closed the menu before a link could be clicked.
   Now the WHOLE details (panel included) cancels the pending close on
   pointerenter, the close delay is longer, and a CSS hover bridge fills the gap.
   Blur/ESC close is left to Dawn's HeaderMenu (focusout on the <header-menu>). */
(() => {
  const fine = window.matchMedia('(pointer: fine)').matches;
  const megas = [...document.querySelectorAll('header-menu details.mega-menu')];
  if (!megas.length) return;

  const syncDim = () => {
    const anyOpen = megas.some((d) => d.open);
    document.body.classList.toggle('kashira-mega-open', anyOpen);
  };

  megas.forEach((details) => {
    const summary = details.querySelector('summary');
    let openTimer = null;
    let closeTimer = null;

    if (fine) {
      const cancelClose = () => clearTimeout(closeTimer);

      // Open on summary hover after a 150ms intent delay.
      summary.addEventListener('pointerenter', () => {
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => {
          if (!details.open) {
            megas.forEach((d) => d !== details && d.removeAttribute('open'));
            details.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');
            syncDim();
          }
        }, 150);
      });

      // Entering ANY part of the details — summary OR the panel — cancels a
      // pending close. This is what keeps the menu open once the pointer bridges
      // the gap and reaches the panel.
      details.addEventListener('pointerenter', cancelClose);

      // Leaving the details closes it after a longer grace delay, giving the
      // pointer time to cross into the panel (where pointerenter re-cancels).
      details.addEventListener('pointerleave', () => {
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          syncDim();
        }, 240);
      });
    }

    details.addEventListener('toggle', syncDim);

    // Arrow-key traversal across columns / within a column
    details.addEventListener('keydown', (e) => {
      if (!['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(e.key)) return;
      const columns = [...details.querySelectorAll('.mega-menu__list > li')].map((li) => [
        ...li.querySelectorAll('a'),
      ]);
      const flat = columns.flat();
      const current = document.activeElement;
      if (!flat.includes(current)) return;
      e.preventDefault();
      const colIndex = columns.findIndex((col) => col.includes(current));
      const rowIndex = columns[colIndex].indexOf(current);
      let target = null;
      if (e.key === 'ArrowDown') target = columns[colIndex][rowIndex + 1];
      if (e.key === 'ArrowUp') target = columns[colIndex][rowIndex - 1];
      if (e.key === 'ArrowRight') target = (columns[colIndex + 1] || [])[Math.min(rowIndex, (columns[colIndex + 1] || []).length - 1)];
      if (e.key === 'ArrowLeft') target = (columns[colIndex - 1] || [])[Math.min(rowIndex, (columns[colIndex - 1] || []).length - 1)];
      target?.focus();
    });
  });

  // Close on scroll (spec)
  let lastY = window.scrollY;
  window.addEventListener(
    'scroll',
    () => {
      if (Math.abs(window.scrollY - lastY) > 24) {
        megas.forEach((d) => {
          if (d.open) {
            d.removeAttribute('open');
            d.querySelector('summary')?.setAttribute('aria-expanded', 'false');
          }
        });
        syncDim();
      }
      lastY = window.scrollY;
    },
    { passive: true }
  );
})();
